<template>
	<div>
		<div class="row">
			<div class="input-field col s12 m12 l12 xl12">
				<input id="nome" name="nome" type="text" class="validate" v-model='sub.nome' maxlength="50" required>
				<label for="nome">Nome</label>
			</div>
		</div>
		<div class="row">	
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn"><i class="material-icons left">save</i>Salvar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
      name: "VueAvalSubgrupoForm",
      props: [
        'subgrupo',
      ],
      data () {
        return {
          sub: JSON.parse(this.subgrupo),
        }
      },
    }
</script>
